module.exports = __webpack_public_path__ + "static/media/lcg-shape-purple.48d44689.svg";